import { useContext } from "react";
import { MediaQueryContext } from "./provider";

export const useMedia = () => {
  const { isMobile, isDesktopSm } = useContext(MediaQueryContext);

  return { isMobile, isDesktopSm };
};
